// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrap":"FormHeader_breadcrumbWrap__1U9G7","breadcrumb":"FormHeader_breadcrumb__pQEG4","breadcrumbText":"FormHeader_breadcrumbText__Maja5"};